/** HTML number input step for shareholding fields (0–100, two decimal places). */
export const SHAREHOLDING_PERCENT_STEP = 0.01;

export const shareholdingPercentInputProps = {
  min: 0,
  max: 100,
  step: SHAREHOLDING_PERCENT_STEP,
};

/**
 * Parse user or API input; preserve up to two decimal places (no integer rounding).
 * @returns {number|null}
 */
export function parseShareholdingPercent(value) {
  if (value === '' || value == null) return null;
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  return Math.round(num * 100) / 100;
}

/** Alias for API/DB values — same precision rules as parse. */
export const normalizeShareholdingPercent = parseShareholdingPercent;

/**
 * Format shareholding for display (up to two decimals).
 * @param {number|string|null|undefined} value
 * @param {{ suffix?: boolean }} [options]
 */
export function formatShareholdingPercent(value, { suffix = true } = {}) {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  const formatted = num.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  return suffix ? `${formatted}%` : formatted;
}
